import React, { Component, Fragment } from 'react';
import { Menu } from 'antd';
import { Link, Route, Switch } from 'react-router-dom';
import { TradeView } from './TradeView';
import { SettingsView } from './SettingsView';
import { StatusPanel } from './StatusPanel';
import { SessionsView } from './SessionsView';
import { SessionPositionsView } from './SessionPositionsView';
import { inject, observer } from 'mobx-react';
import LoadingScreen from 'react-loading-screen';
import { IndicatorsView } from './IndicatorsView';
import { SignalsView } from './SignalsView';
import { LogsView } from './LogsView';
import { LeaderboardView } from './LeaderboardView';

@inject('store')
@observer
export class LeverageBotView extends Component {
    async componentDidMount() {
        await this.props.store.odysseyBotStore.getConfig(this.props.match.params.id);
        this.props.store.odysseyBotStore.connectToStream();
    }

    render() {
        const botId = this.props.match.params.id;
        const { config } = this.props.store.odysseyBotStore;

        if (!config) {
            return (
                <LoadingScreen
                    loading={true}
                    logoSrc={'/logo.png'}
                    text={'Loading trading terminal'}
                >
                    <span />
                </LoadingScreen>
            );
        }

        return (
            <Fragment>
                <StatusPanel>
                    <Menu mode="horizontal">
                        <Menu.Item key="sessions">
                            <Link to={`/a/odyssey/${botId}/sessions`}>Trading Sessions</Link>
                        </Menu.Item>
                        <Menu.Item key="trade">
                            <Link to={`/a/odyssey/${botId}/trade`}>Trade</Link>
                        </Menu.Item>
                        <Menu.Item key="indicators">
                            <Link to={`/a/odyssey/${botId}/indicators`}>Indicators</Link>
                        </Menu.Item>
                        <Menu.Item key="signals">
                            <Link to={`/a/odyssey/${botId}/signals`}>Signals</Link>
                        </Menu.Item>
                        <Menu.Item key="logs">
                            <Link to={`/a/odyssey/${botId}/logs`}>Logs</Link>
                        </Menu.Item>
                        <Menu.Item key="settings">
                            <Link to={`/a/odyssey/${botId}/settings`}>Settings</Link>
                        </Menu.Item>
                        <Menu.Item key="leaderboard">
                            <Link to={`/a/odyssey/${botId}/leaderboard`}>Leaderboard</Link>
                        </Menu.Item>
                    </Menu>
                </StatusPanel>

                <Switch>
                    <Route exact path="/a/odyssey/:id/trade" component={TradeView} />
                    <Route exact path="/a/odyssey/:id/sessions" component={SessionsView} />
                    <Route
                        exact
                        path="/a/odyssey/:id/sessions/:session_id"
                        component={SessionPositionsView}
                    />
                    <Route exact path="/a/odyssey/:id/signals" component={SignalsView} />
                    <Route exact path="/a/odyssey/:id/settings" component={SettingsView} />
                    <Route exact path="/a/odyssey/:id/indicators" component={IndicatorsView} />
                    <Route exact path="/a/odyssey/:id/logs" component={LogsView} />
                    <Route exact path="/a/odyssey/:id/leaderboard" component={LeaderboardView} />
                </Switch>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/index.js